<template>
  <g>
    <border stroke="#ff4961" />
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      x="7"
      y="7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9502 1.05038C11.2041 1.30423 11.2041 1.71578 10.9502 1.96962L1.96997 10.9499C1.71613 11.2037 1.30457 11.2037 1.05073 10.9499C0.796891 10.696 0.796891 10.2845 1.05073 10.0306L10.031 1.05038C10.2848 0.796544 10.6964 0.796544 10.9502 1.05038Z"
        fill="#FF4961"
      />
      <path
        d="M10.9503 10.9499C10.6964 11.2037 10.2849 11.2037 10.031 10.9499L1.05078 1.9696C0.79694 1.71576 0.79694 1.30421 1.05078 1.05037C1.30462 0.796525 1.71618 0.796525 1.97002 1.05037L10.9503 10.0306C11.2041 10.2845 11.2041 10.696 10.9503 10.9499Z"
        fill="#FF4961"
      />
    </svg>
  </g>
</template>

<script>
  import Border from './_border';
  export default {
    components: {
      Border
    }
  };
</script>
